<template>
	<div class="row sec_report graph-container">
    <template v-if="isProgram">
			<div class="col-12 hd ace_sec_hd">
        <span v-if="!isAdvisor">Top Program Views</span>
        <span v-if="isAdvisor">{{adviseeNameToShow}}'s Top Program Views</span>
			</div>
			<div class="report_list">
	      <ul>
	        <li v-for="p in programs.userList"><b-link :to="{ name: 'programGuideIntroduction', params: {cipCode: p.cipCode, programGuideCode: p.code,type: 'MAJOR'} }">{{p.name}}</b-link></li>
	      </ul>
			</div>

			<div class="col-12 hd ace_sec_hd">
				<span>Institution's Top Program Views</span>
			</div>
			<div class="report_list">
	      <ul>
	        <li v-for="p in programs.institutionList"><b-link :to="{ name: 'programGuideIntroduction', params: {cipCode: p.cipCode, programGuideCode: p.code,type: 'MAJOR'} }">{{p.name}}</b-link></li>
	      </ul>
			</div>
    </template>

    <template v-if="!isProgram">
			<div class="col-12 hd ace_sec_hd">
				<span v-if="!isAdvisor">Top Careers Views</span>
        <span v-if="isAdvisor">{{adviseeNameToShow}}'s Top Careers Views</span>
			</div>
			<div class="report_list">
	      <ul>
	        <li v-for="c in careers.userList"><b-link :to="{ name: 'careerDetail', params: {code: c.pragyaSoc} }">{{c.name}}</b-link></li>
	      </ul>
			</div>

			<div class="col-12 hd ace_sec_hd">
				<span>Institution's Top Career Views</span>
			</div>
			<div class="report_list">
	      <ul>
	        <li v-for="c in careers.institutionList"><b-link :to="{ name: 'careerDetail', params: {code: c.pragyaSoc} }">{{c.name}}</b-link></li>
	      </ul>
			</div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BarChart from './BarChart'
import DonutChart from './DonutChart'

export default {
  name: 'reportCompare',
  props: ['selectedReport', 'timeperiod', 'type', 'isProgram',  'isAdvisor', 'adviseeName'],
  components: {
    BarChart,
    DonutChart
  },
  data: () => {
    return {
      response: {},
      careers: {
        userList: [
          {
            'name': 'Account Executive',
            'code': '43-6011.92'
          },
          {
            'name': 'Business / Management Analyst',
            'code': '13-1111.00'
          },
          {
            'name': 'Operations Analyst',
            'code': '15-2031.00'
          },
          {
            'name': 'Advertising Sales Representative',
            'code': '41-3011.00'
          },
          {
            'name': 'Business Development / Sales Manager',
            'code': '11-2022.00'
          }
        ],
        institutionList: [
          {
            'name': 'Business / Management Analyst',
            'code': '13-1111.00'
          },
          {
            'name': 'Operations Analyst',
            'code': '15-2031.00'
          },
          {
            'name': 'Business Development / Sales Manager',
            'code': '11-2022.00'
          },
          {
            'name': 'Advertising Sales Representative',
            'code': '41-3011.00'
          },
          {
            'name': 'Account Executive',
            'code': '43-6011.92'
          }
        ]
      },
      programs: {
        userList: [
          {
            'name': 'Accounting Degree Program',
            'code': 'BSBUSACC',
            'cipCode': '52.0301'
          },
          {
            'name': 'Data Analytics Degree Program',
            'code': 'BABUSDANY',
            'cipCode': '11.0301'
          },
          {
            'name': 'Finance Degree Program',
            'code': 'BSBUSFIN',
            'cipCode': '52.0801'
          },
          {
            'name': 'International Management Degree Program',
            'code': 'IMCONC',
            'cipCode': '52.0101'
          }
        ],
        institutionList: [
          {
            'name': 'Accounting Degree Program',
            'code': 'BSBUSACC',
            'cipCode': '52.0301'
          },
          {
            'name': 'Data Analytics Degree Program',
            'code': 'BABUSDANY',
            'cipCode': '11.0301'
          },
          {
            'name': 'Finance Degree Program',
            'code': 'BSBUSFIN',
            'cipCode': '52.0801'
          },
          {
            'name': 'International Management Degree Program',
            'code': 'IMCONC',
            'cipCode': '52.0101'
          },
          {
            'name': 'Sports Management Degree Program',
            'code': 'SMCONC',
            'cipCode': '52.0101'
          }
        ]
      }
    }
  },
  mounted () {
    this.loadReport()
  },
  methods: {
    ...mapActions([
      'loadReportQuery'
    ]),

    async loadReport () {
    }
  },
  computed: {
    ...mapState({
    }),
    adviseeNameToShow () {
      if (this.adviseeName) {
        return this.adviseeName
      } else {
        'Student'
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/institution/components/ReportCompare.vue